import { Component, OnInit, ViewChild } from '@angular/core';
import { Organization } from '../../types/organization';
import { OrganizationService } from '../../services/organization.service';
import { ForgotPasswordService } from '../../services/forgot-password.service';
import { LogService } from '../../services/log.service';
import { BaseForm } from '../../interfaces/BaseForm';
import { PasswordPolicyService } from '../../services/password-policy.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent extends BaseForm implements OnInit {
  username: string;
  organization: Organization;
  @ViewChild('usernameInput')
  usernameInput;

  constructor(
    private log: LogService,
    private orgService: OrganizationService,
    private passwordPolicy: PasswordPolicyService,
    private forgotPasswordService: ForgotPasswordService
  ) {
    super(log);
  }

  ngOnInit() {
    this.clear();

    this.errorHandler.setGenericMessage(
      'Failed to initiate password reset. Please check your credentials and try again.'
    );

    this.log.trace('forgot-password form loaded');
  }

  isValid(): boolean {
    if (this.isSubmitInProgress || !this.username) {
      return false;
    }
    return true;
  }

  clear() {
    this.username = '';
    this.organization = null;
    this.usernameInput.nativeElement.focus();
  }

  submit() {
    this.isSubmitInProgress = true;

    // Pre-cache the password policy
    this.passwordPolicy.getPasswordPolicy(null, this.username).subscribe();
    
    this.forgotPasswordService.forgotPassword(
      this.username,
      this.onErrorCallback
    ); 
  }
}
